import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:9090/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jeil_token')
  if (token) config.headers.Authorization = `Bearer ${token}`

  // 회사(사업장) 구분을 헤더에 명시적으로 포함 — 백엔드가 토큰 외에도 참조 가능
  try {
    const user = JSON.parse(localStorage.getItem('jeil_user'))
    if (user?.locationId != null) {
      config.headers['X-Location-Id'] = user.locationId
    }
  } catch { /* ignore */ }

  return config
})

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status
    const hasToken = !!localStorage.getItem('jeil_token')

    // 토큰이 있는 상태에서 401 = 세션 만료
    if (status === 401 && hasToken) {
      localStorage.removeItem('jeil_token')
      localStorage.removeItem('jeil_user')
      sessionStorage.setItem('jeil_expired_msg', '세션이 만료되었습니다. 다시 로그인해 주세요.')
      window.location.href = '/login'
      // 컴포넌트의 catch 블록이 실행되지 않도록 resolve되지 않는 Promise 반환
      return new Promise(() => {})
    }

    return Promise.reject(error)
  }
)

export default api
